import React, { useState } from "react";
import { useTranslation } from "@helpers/translate";
import { useSelector } from "react-redux";

import CountrySelect from "../CountrySelect";
import { useCountries } from "@components/pages/MyProfile/components/ProfileTab/hooks/useCountries";

import PaymentMethods from "../PaymentMethods";

import "./index.sass";

const DepositMethodStep = ({ selectedMethod, onSelectMethod }) => {
  const { __ } = useTranslation();

  const { locale } = useSelector((state) => state.localization);

  // Тимчасово не використовуємо країну з профілю.
  // Наразі за вимогами завжди показуємо Україну.
  // Після повернення логіки роботи з країнами потрібно
  // повернути user зі store та розкоментувати useEffect нижче.

  // const user = useSelector((state) => state.user.user);

  const { countries } = useCountries(locale);

  // Тимчасово фіксуємо Україну як єдину доступну країну.
  const [country, setCountry] = useState("UA");

  const [methodSearch, setMethodSearch] = useState("");

  /*
useEffect(() => {
  if (!user?.country) return;

  setCountry(user.country);
}, [user?.country]);
*/

  const handleMethodSearchChange = (e) => {
    setMethodSearch(e.target.value);
  };

  return (
    <div className="deposit-method-step">
      <div className="deposit-method-step__top">
        <div className="deposit-method-step__selectors">
          <div className="deposit-method-step__field">
            <label>{__("wallet.deposit.country_region")}</label>

            <CountrySelect
              countries={countries}
              value={country}
              locale={locale}
              onChange={setCountry}
              placeholder={__("wallet.deposit.country_region")}
              disabled
            />
          </div>

          <div className="deposit-method-step__field deposit-method-step__field--search">
            <div className="deposit-method-step__search-wrap">
              <input
                type="text"
                placeholder={__("wallet.deposit.search")}
                value={methodSearch}
                onChange={handleMethodSearchChange}
                className="deposit-method-step__search"
              />

              <button
                type="button"
                className="deposit-method-step__search-icon"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.3534 13.6467L11.7927 11.086C12.6487 10.0707 13.1667 8.762 13.1667 7.33333C13.1667 4.11667 10.55 1.5 7.33333 1.5C4.11667 1.5 1.5 4.11667 1.5 7.33333C1.5 10.55 4.11667 13.1667 7.33333 13.1667C8.762 13.1667 10.0707 12.6487 11.086 11.7927L13.6466 14.3533C13.744 14.4507 13.872 14.5 14 14.5C14.128 14.5 14.256 14.4513 14.3534 14.3533C14.5487 14.1587 14.5487 13.842 14.3534 13.6467ZM2.5 7.33333C2.5 4.668 4.668 2.5 7.33333 2.5C9.99867 2.5 12.1667 4.668 12.1667 7.33333C12.1667 9.99867 9.99867 12.1667 7.33333 12.1667C4.668 12.1667 2.5 9.99867 2.5 7.33333Z"
                    fill="white"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>

        <div className="deposit-method-step__rules">
          <ul>
            <li>
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.6083 3.77502L15.2083 3.17504V5.83333C15.2083 6.17833 15.4883 6.45833 15.8333 6.45833C16.1783 6.45833 16.4583 6.17833 16.4583 5.83333V3.17586L17.0583 3.77583C17.18 3.8975 17.34 3.95914 17.5 3.95914C17.66 3.95914 17.82 3.89833 17.9417 3.77583C18.1858 3.53167 18.1858 3.1358 17.9417 2.89164L16.275 1.22497C16.2175 1.16747 16.1483 1.12165 16.0717 1.08998C15.9192 1.02665 15.7467 1.02665 15.5942 1.08998C15.5175 1.12165 15.4483 1.16747 15.3908 1.22497L13.7242 2.89164C13.48 3.1358 13.48 3.53167 13.7242 3.77583C13.9683 4.02 14.3642 4.01919 14.6083 3.77502ZM9.70833 7.38413H10.2917C10.7683 7.38413 11.1675 7.74246 11.2217 8.21746C11.26 8.5608 11.5667 8.81079 11.9125 8.76912C12.2558 8.73079 12.5025 8.42164 12.4642 8.0783C12.3517 7.07497 11.5742 6.30249 10.6025 6.16332V5.83333C10.6025 5.48833 10.3225 5.20833 9.97749 5.20833C9.63249 5.20833 9.35249 5.48833 9.35249 5.83333V6.17085C8.31749 6.34252 7.52416 7.2375 7.52416 8.32C7.52416 8.80917 7.68833 9.28751 7.98416 9.66084C8.28083 10.0433 8.70418 10.32 9.17918 10.44L10.5192 10.7725C10.9367 10.8783 11.2283 11.2517 11.2283 11.68C11.2283 11.9283 11.1308 12.1625 10.9533 12.34C10.7758 12.5175 10.5417 12.6149 10.2933 12.6149H9.71001C9.23334 12.6149 8.83418 12.2566 8.78001 11.7816C8.74168 11.4383 8.42917 11.1866 8.08917 11.23C7.74583 11.2683 7.49918 11.5775 7.53751 11.9209C7.64834 12.91 8.405 13.6775 9.3575 13.8317V14.1667C9.3575 14.5117 9.6375 14.7917 9.9825 14.7917C10.3275 14.7917 10.6075 14.5117 10.6075 14.1667V13.835C11.07 13.7675 11.4992 13.5625 11.8367 13.225C12.25 12.8117 12.4783 12.2633 12.4783 11.6808C12.4783 10.6791 11.7992 9.80751 10.8233 9.56085L9.48334 9.22831C9.27667 9.17664 9.10083 9.06086 8.96833 8.8917C8.84333 8.73336 8.77416 8.52998 8.77416 8.32082C8.77333 7.80415 9.19249 7.38413 9.70833 7.38413ZM17.5 7.70833C17.155 7.70833 16.875 7.98833 16.875 8.33333V14.6833C16.875 16.1992 16.1992 16.875 14.6833 16.875H5.31667C3.78084 16.875 3.125 16.2192 3.125 14.6833V5.30832C3.125 3.77832 3.78084 3.12499 5.31667 3.12499H11.6667C12.0117 3.12499 12.2917 2.84499 12.2917 2.49999C12.2917 2.15499 12.0117 1.87499 11.6667 1.87499H5.31667C3.0975 1.87499 1.875 3.09416 1.875 5.30832V14.6833C1.875 16.9025 3.0975 18.125 5.31667 18.125H14.6833C16.9025 18.125 18.125 16.9025 18.125 14.6833V8.33333C18.125 7.98833 17.845 7.70833 17.5 7.70833Z"
                  fill="#FF6C22"
                />
              </svg>
              {__("wallet.deposit.minimum_deposit_amount")}
              <span>{"10 USDT"}</span>
            </li>

            <li>
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.7915 15.0002C9.7915 15.3452 9.5115 15.6252 9.1665 15.6252H4.1665C2.1515 15.6252 1.0415 14.5152 1.0415 12.5002V5.8335C1.0415 3.8185 2.1515 2.7085 4.1665 2.7085H14.1665C16.1815 2.7085 17.2915 3.8185 17.2915 5.8335V8.3335C17.2915 8.6785 17.0115 8.9585 16.6665 8.9585C16.3215 8.9585 16.0415 8.6785 16.0415 8.3335V5.8335C16.0415 4.51933 15.4807 3.9585 14.1665 3.9585H4.1665C2.85234 3.9585 2.2915 4.51933 2.2915 5.8335V12.5002C2.2915 13.8143 2.85234 14.3752 4.1665 14.3752H9.1665C9.5115 14.3752 9.7915 14.6552 9.7915 15.0002ZM3.33317 9.16683C3.33317 9.62683 3.7065 10.0002 4.1665 10.0002C4.6265 10.0002 4.99984 9.62683 4.99984 9.16683C4.99984 8.70683 4.6265 8.3335 4.1665 8.3335C3.7065 8.3335 3.33317 8.70683 3.33317 9.16683ZM9.1665 6.04183C10.8898 6.04183 12.2915 7.4435 12.2915 9.16683C12.2915 10.8902 10.8898 12.2918 9.1665 12.2918C7.44317 12.2918 6.0415 10.8902 6.0415 9.16683C6.0415 7.4435 7.44317 6.04183 9.1665 6.04183ZM9.1665 7.29183C8.13234 7.29183 7.2915 8.13266 7.2915 9.16683C7.2915 10.201 8.13234 11.0418 9.1665 11.0418C10.2007 11.0418 11.0415 10.201 11.0415 9.16683C11.0415 8.13266 10.2007 7.29183 9.1665 7.29183ZM18.9582 14.1668C18.9582 16.3493 17.1823 18.1252 14.9998 18.1252C12.8173 18.1252 11.0415 16.3493 11.0415 14.1668C11.0415 11.9843 12.8173 10.2085 14.9998 10.2085C17.1823 10.2085 18.9582 11.9843 18.9582 14.1668ZM17.7082 14.1668C17.7082 12.6735 16.4932 11.4585 14.9998 11.4585C13.5065 11.4585 12.2915 12.6735 12.2915 14.1668C12.2915 15.6602 13.5065 16.8752 14.9998 16.8752C16.4932 16.8752 17.7082 15.6602 17.7082 14.1668ZM15.5998 13.0302L14.6532 13.9768L14.4007 13.7243C14.1565 13.481 13.7607 13.4802 13.5165 13.7243C13.2723 13.9685 13.2723 14.3644 13.5165 14.6085L14.2107 15.3026C14.3323 15.4243 14.4923 15.4851 14.6523 15.4851C14.8123 15.4851 14.9723 15.4243 15.094 15.3018L16.4832 13.9127C16.7273 13.6685 16.7273 13.2726 16.4832 13.0285C16.239 12.7868 15.844 12.7868 15.5998 13.0302Z"
                  fill="#FF6C22"
                />
              </svg>
              {__("wallet.deposit.quick_withdrawal")}
            </li>

            <li>
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.5 7.70817C17.155 7.70817 16.875 7.98817 16.875 8.33317V14.6832C16.875 16.199 16.1992 16.8748 14.6833 16.8748H5.31667C3.78084 16.8748 3.125 16.219 3.125 14.6832V5.30817C3.125 3.77817 3.78084 3.12484 5.31667 3.12484H11.6667C12.0117 3.12484 12.2917 2.84484 12.2917 2.49984C12.2917 2.15484 12.0117 1.87484 11.6667 1.87484H5.31667C3.0975 1.87484 1.875 3.094 1.875 5.30817V14.6832C1.875 16.9023 3.0975 18.1248 5.31667 18.1248H14.6833C16.9025 18.1248 18.125 16.9023 18.125 14.6832V8.33317C18.125 7.98817 17.845 7.70817 17.5 7.70817ZM15.3917 6.27486C15.4492 6.33236 15.5183 6.37818 15.595 6.40985C15.6717 6.44152 15.7525 6.45817 15.8342 6.45817C15.9158 6.45817 15.9967 6.44152 16.0733 6.40985C16.15 6.37818 16.2192 6.33236 16.2767 6.27486L17.9433 4.6082C18.1875 4.36403 18.1875 3.96817 17.9433 3.724C17.6992 3.47983 17.3033 3.47983 17.0592 3.724L16.4592 4.32397V1.6665C16.4592 1.3215 16.1792 1.0415 15.8342 1.0415C15.4892 1.0415 15.2092 1.3215 15.2092 1.6665V4.32397L14.6092 3.724C14.365 3.47983 13.9692 3.47983 13.725 3.724C13.4808 3.96817 13.4808 4.36403 13.725 4.6082L15.3917 6.27486ZM9.70833 7.38397H10.2917C10.7683 7.38397 11.1675 7.74231 11.2217 8.21731C11.26 8.56064 11.5675 8.81063 11.9125 8.76896C12.2558 8.73063 12.5025 8.42148 12.4642 8.07815C12.3517 7.07648 11.5767 6.304 10.6067 6.16317V5.83317C10.6067 5.48817 10.3267 5.20817 9.98166 5.20817C9.63666 5.20817 9.35666 5.48817 9.35666 5.83317V6.16988C8.31916 6.33988 7.52333 7.23486 7.52333 8.31903C7.52333 8.8082 7.6875 9.28654 7.98333 9.65987C8.28 10.0424 8.70334 10.319 9.17834 10.439L10.5183 10.7715C10.9358 10.8774 11.2275 11.2507 11.2275 11.679C11.2275 11.9274 11.13 12.1615 10.9525 12.339C10.775 12.5165 10.5408 12.614 10.2925 12.614H9.70917C9.2325 12.614 8.83334 12.2556 8.77917 11.7806C8.74084 11.4373 8.42999 11.1857 8.08833 11.229C7.74499 11.2673 7.49834 11.5765 7.53667 11.9198C7.64751 12.909 8.40416 13.6765 9.35666 13.8307V14.1665C9.35666 14.5115 9.63666 14.7915 9.98166 14.7915C10.3267 14.7915 10.6067 14.5115 10.6067 14.1665V13.8349C11.0692 13.7674 11.4983 13.5623 11.8358 13.2248C12.2492 12.8115 12.4775 12.2631 12.4775 11.6806C12.4775 10.679 11.7983 9.80736 10.8225 9.56069L9.4825 9.22815C9.27583 9.17648 9.1 9.06071 8.9675 8.89154C8.8425 8.73321 8.77333 8.52983 8.77333 8.32066C8.77333 7.80399 9.19249 7.38397 9.70833 7.38397Z"
                  fill="#FF6C22"
                />
              </svg>
              {__("wallet.deposit.minimum_withdrawal_amount")}
              <span>{"10 USDT"}</span>
            </li>

            <li>
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.66667 13.9583C6.50667 13.9583 6.34664 13.8975 6.22498 13.775C5.98081 13.5309 5.98081 13.135 6.22498 12.8908L12.8916 6.22416C13.1358 5.97999 13.5317 5.97999 13.7758 6.22416C14.02 6.46833 14.02 6.86419 13.7758 7.10836L7.10917 13.775C6.98667 13.8975 6.82667 13.9583 6.66667 13.9583ZM13.9583 12.2917C13.9583 11.3725 13.2108 10.625 12.2917 10.625C11.3725 10.625 10.625 11.3725 10.625 12.2917C10.625 13.2108 11.3725 13.9583 12.2917 13.9583C13.2108 13.9583 13.9583 13.2108 13.9583 12.2917ZM12.7083 12.2917C12.7083 12.5217 12.5217 12.7083 12.2917 12.7083C12.0617 12.7083 11.875 12.5217 11.875 12.2917C11.875 12.0617 12.0617 11.875 12.2917 11.875C12.5217 11.875 12.7083 12.0617 12.7083 12.2917ZM9.375 7.70833C9.375 6.78917 8.6275 6.04167 7.70833 6.04167C6.78917 6.04167 6.04167 6.78917 6.04167 7.70833C6.04167 8.6275 6.78917 9.375 7.70833 9.375C8.6275 9.375 9.375 8.6275 9.375 7.70833ZM8.125 7.70833C8.125 7.93833 7.93833 8.125 7.70833 8.125C7.47833 8.125 7.29167 7.93833 7.29167 7.70833C7.29167 7.47833 7.47833 7.29167 7.70833 7.29167C7.93833 7.29167 8.125 7.47833 8.125 7.70833ZM18.125 14.6875V5.3125C18.125 3.09583 16.9042 1.875 14.6875 1.875H5.3125C3.09583 1.875 1.875 3.09583 1.875 5.3125V14.6875C1.875 16.9042 3.09583 18.125 5.3125 18.125H14.6875C16.9042 18.125 18.125 16.9042 18.125 14.6875ZM14.6875 3.125C16.2208 3.125 16.875 3.77917 16.875 5.3125V14.6875C16.875 16.2208 16.2208 16.875 14.6875 16.875H5.3125C3.77917 16.875 3.125 16.2208 3.125 14.6875V5.3125C3.125 3.77917 3.125 3.125 5.3125 3.125H14.6875Z"
                  fill="#FF6C22"
                />
              </svg>
              {__("wallet.deposit.no_commission")}
            </li>
          </ul>
        </div>
      </div>

      <PaymentMethods
        selectedMethod={selectedMethod}
        searchQuery={methodSearch}
        onSelect={onSelectMethod}
      />
    </div>
  );
};

export default DepositMethodStep;
